import {
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Text,
} from "@chakra-ui/react";
import {
  FaDownload,
  FaFileAlt,
  FaFileArchive,
  FaFileCode,
  FaFileExcel,
  FaFilePdf,
} from "react-icons/fa";
import { getExportText } from "../Helpers/exportI18n";

export default function ExportReportMenu({ OnExport, language, t, isExporting = false }) {
  return (
    <Menu>
      <MenuButton as={Button} size="sm" variant="solid" isLoading={isExporting} isDisabled={isExporting}>
        <HStack spacing={1}>
          {isExporting ? <Spinner size="sm" /> : <FaDownload />}
          <Text>{getExportText(t, language, "reports.exportReport", "تصدير التقرير", "Export Report")}</Text>
        </HStack>
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => OnExport("pdf")} icon={<FaFilePdf />} isDisabled={isExporting}>
          PDF ({getExportText(t, language, "reports.fullReport", "التقرير الكامل", "Full Report")})
        </MenuItem>
        <MenuItem onClick={() => OnExport("excel")} icon={<FaFileExcel />} isDisabled={isExporting}>
          Excel ({getExportText(t, language, "reports.singleSheet", "ورقة واحدة", "Single Sheet")})
        </MenuItem>
        <MenuItem onClick={() => OnExport("csv")} icon={<FaFileArchive />} isDisabled={isExporting}>
          CSV ZIP ({getExportText(t, language, "reports.multipleFiles", "ملفات متعددة", "Multiple Files")})
        </MenuItem>
        <MenuItem onClick={() => OnExport("text")} icon={<FaFileAlt />} isDisabled={isExporting}>
          Text ({getExportText(t, language, "reports.textOnly", "النص فقط", "Text Only")})
        </MenuItem>
        <MenuItem onClick={() => OnExport("prompt")} icon={<FaFileCode />} isDisabled={isExporting}>
          TXT ({getExportText(t, language, "reports.aiPrompt", "برومبت التحليل", "AI Prompt")})
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
